import cn from 'classnames';
import styles from './Pill.module.css';

type Props = {
  variant?: 'default' | 'alert' | 'success';
  size?: 'small' | 'large';
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;
  children?: React.ReactNode;
  className?: string;
  ref?: React.Ref<HTMLSpanElement>;
};

export function Pill({ variant = 'default', size = 'small', Icon, children, className, ref }: Props) {
  const classes = cn(styles.Pill, styles[`Pill___${variant}`], styles[`Pill___${size}`], className);

  return (
    <span className={classes} ref={ref}>
      {Icon && <Icon height={10} width={10} className="shrink-0" aria-hidden={true} />}
      <div className="truncate">{children}</div>
    </span>
  );
}
